import React, { Component } from 'react';
import Graph from 'react-graph-vis';
import CytoscapeComponent from 'react-cytoscapejs';
import * as styles from './styles.js';
import * as DG from './dataGenerators.js';
import cytoscape, { Stylesheet } from 'cytoscape';
import dagre from 'cytoscape-dagre';
let adj = new Array(9);
for (let index = 0; index < adj.length; index++) {
    adj[index] = new Array(9).fill(0);
}
cytoscape.use(dagre);
var dij;
const random_nodeids = DG.randomNodeIds();
// const elements = CytoscapeComponent.normalizeElements({
//     nodes: DG.randomNodes(random_nodeids),
//     edges: DG.randomEdgesWithWeights(random_nodeids),
// });
const elements = {
    edges: DG.randomEdgesWithWeights(random_nodeids),
};
const vis_node = '#A5D6A7';
const unvis_node = '#B2EBF2';
const source_node = '#ff6666';
const selected = '#A5D6A7';
let nod = 0;
let edgesList = [
    [0, 1, 15],
    [0, 2, 13],
    [1, 3, 14],
    [1, 4, 4],
    [2, 5, 12],
    [2, 6, 8],
    [3, 7, 1],
    [3, 8, 11],
    [0, 7, 6],
    [0, 5, 2],
    // [4, 0, 3],
    // [6, 0, 3],
    // [4, 8, 10],
    // [6, 8, 5],
    // [7, 8, 7],
];
let edges = [];
function getDefaultStylesheet() {
    return [{ selector: 'node', style: { label: 'data(label)' } }];
}
for (let index = 0; index < edgesList.length; index++) {
    const edge = edgesList[index];
    edges.push({ from: edge[0], to: edge[1], label: edge[2] + '' });
    adj[edge[0]][edge[1]] = edge[2];
}
document.title = 'Shortest Path Arbitrary';
function minDistance(dist, sptSet) {
    // Initialize min value
    let min = Number.MAX_VALUE;
    let min_index = -1;

    for (let v = 0; v < 9; v++) {
        if (sptSet[v] === false && dist[v] <= min) {
            min = dist[v];
            min_index = v;
        }
    }
    return min_index;
}

function dijkstra(g, src) {
    let dist = new Array(9);
    let sptSet = new Array(9);
    for (let index = 0; index < 9; index++) {
        dist[index] = Number.MAX_VALUE;
        sptSet[index] = false;
    }
    dist[src] = 0;
    for (let count = 0; count < 9 - 1; count++) {
        let u = minDistance(dist, sptSet);
        sptSet[u] = true;
        for (let v = 0; v < 9; v++) {
            if (
                !sptSet[v] &&
                g[u][v] !== 0 &&
                dist[u] !== Number.MAX_VALUE &&
                dist[u] + g[u][v] < dist[v]
            ) {
                dist[v] = dist[u] + g[u][v];
            }
        }
    }
    return dist;
}
let distances = dijkstra(adj, 0);
const options = {
    // layout: {
    //     hierarchical: true,
    // },
    edges: {
        color: '#000000',
    },
    height: '100%',
    width: '100%',
    physics: {
        enabled: false,
    },
};
var graph_cy;
export default class Arbitary extends Component {
    constructor(props) {
        super(props);
        let dust0bject = {};
        for (const key in random_nodeids) {
            dust0bject[String(random_nodeids[key])] = -1;
        }
        this.state = {
            instruction: 'Select a node',
            stage: 0,
            d: '',
            snode: -1,
            distFound: dust0bject,
        };
        this.selectNode = this.selectNode.bind(this);
        this.changeD = this.changeD.bind(this);
        this.setDist = this.setDist.bind(this);
    }
    changeD(event) {
        this.setState({ d: event.target.value });
    }
    selectNode(event, cy) {
        if (this.state.stage === 2) return;
        var node = event.target.id();
        console.log(dij.distanceTo(event.target));
        console.log(random_nodeids);
        // if (nod === 9) return;
        cy.nodes()
            .filter((eg) => eg.hasClass('selected'))
            .removeClass('selected');
        event.target.addClass('selected');
        if (this.state.distFound[node] !== -1) {
            this.setState({
                instruction:
                    'You have already entered distance for node ' +
                    node +
                    '. Plese select another node',
                stage: 0,
            });
        } else {
            this.setState({
                instruction:
                    'You have selected node ' +
                    node +
                    '. Enter the distance below.',
                stage: 1,
                snode: node,
            });
        }
    }
    setDist(event) {
        // console.log('Hello', typeof this.state.d);
        var distFound = this.state.distFound;
        // console.log(distFound);
        const dust = dij.distanceTo(graph_cy.nodes(`#${this.state.snode}`));
        if (dust === Number(this.state.d)) {
            graph_cy.nodes(`#${this.state.snode}`).removeClass('selected');
            graph_cy.nodes(`#${this.state.snode}`).addClass('visited');
            distFound[this.state.snode] = Number(this.state.d);
            nod += 1;
            if (nod === random_nodeids.length) {
                this.setState({
                    distFound,
                    stage: 2,
                    d: '',
                    instruction: 'You found all the distances',
                });
            } else {
                this.setState({
                    distFound,
                    stage: 0,
                    d: '',
                    instruction:
                        'You entered correct distance. Select another node',
                });
            }
        } else {
            this.setState({
                instruction: 'You entered wrong distance. Please enter again',
            });
        }
    }
    render() {
        let nodes = [];
        for (let index = 0; index < 9; index++) {
            nodes.push({
                id: index,
                label:
                    index +
                    ` (${
                        this.state.distFound[index] === -1
                            ? '∞'
                            : this.state.distFound[index]
                    })`,
                shadow: true,
            });
            nodes[index]['color'] =
                this.state.distFound[index] === -1 ? unvis_node : vis_node;
        }
        nodes[0]['color'] = source_node;
        elements['nodes'] = DG.randomNodes(random_nodeids, random_nodeids[0]);
        const elemenst_obj = CytoscapeComponent.normalizeElements(elements);
        const events = {
            selectNode: this.selectNode,
        };
        const ths = [];
        for (let i = 0; i < 9; i++) {
            ths.push(<td>{i}</td>);
        }
        const graph = {
            nodes,
            edges,
        };
        // const [stylesheet, setStylesheet] = React.useState<Stylesheet[]>(
        //     getDefaultStylesheet
        //   );
        const layout = { name: 'dagre' };
        return (
            <div className="content">
                <div className="left-div" style={{ overflow: 'scroll' }}>
                    <h3>Objective</h3>
                    <p>
                        Given a directed graph with non-negative weights, find
                        the shortest path from the source node to every node in
                        the graph.
                    </p>
                    <h3>Color codes</h3>
                    <div className="color-code">
                        <div
                            className="color-bubble"
                            style={{ backgroundColor: source_node }}
                        ></div>
                        <p>Source Node</p>
                    </div>
                    <div className="color-code">
                        <div
                            className="color-bubble"
                            style={{ backgroundColor: unvis_node }}
                        ></div>
                        <p>Unvisited Node</p>
                    </div>
                    <div className="color-code">
                        <div
                            className="color-bubble"
                            style={{ backgroundColor: vis_node }}
                        ></div>
                        <p>Visited Node</p>
                    </div>
                    <div className="color-code">
                        <div
                            className="color-bubble"
                            style={{ backgroundColor: selected }}
                        ></div>
                        <p>Selected Node</p>
                    </div>
                    <h3>Setup</h3>
                    <p>
                        You can click on any node to visit it and attempt to
                        enter the length of its shortest path.
                    </p>
                    <p>
                        If the distance entered by you is correct, the selected
                        node will be annotated with the length of shortest path.
                        Otherwise you get instruction that you entered wrong
                        distance.
                    </p>
                    <h3>Procedure</h3>
                    <p>Step 1: Select a node.</p>
                    <p>
                        Step 2: Enter the shortest distance from source to
                        selected node.
                    </p>
                    <p>
                        Step 3: Repeat from step 1 until you find all the
                        shortest distances.
                    </p>
                </div>
                <div className="right-div">
                    <div className="instruction">
                        <p>{this.state.instruction}</p>
                    </div>
                    <div className="graph">
                        {/* <Graph
                            graph={graph}
                            options={options}
                            events={events}
                            getNetwork={(network) => {
                                //  if you want access to vis.js network api you can set the state in a parent component using this property
                            }}
                        /> */}
                        <CytoscapeComponent
                            style={{ width: '100%', height: '100%' }}
                            stylesheet={styles.graph_style_edge_labels}
                            elements={elemenst_obj}
                            layout={layout}
                            cy={(cy) => {
                                cy.on('click', 'node', (evt) => {
                                    this.selectNode(evt, cy);
                                });
                                cy.ready((evt) => {
                                    cy.nodes(`#${random_nodeids[0]}`).addClass(
                                        'source'
                                    );
                                });
                                dij = cy
                                    .elements()
                                    .dijkstra(
                                        `#${random_nodeids[0]}`,
                                        function (edge) {
                                            return Number(edge.data('weight'));
                                        }
                                    );
                                graph_cy = cy;
                            }}
                        />
                    </div>
                    <div>
                        <p>Distances :</p>
                        <table>
                            <tr>
                                <th>Nodes</th>
                                {Object.keys(this.state.distFound).map((x) => (
                                    <td>{x}</td>
                                ))}
                            </tr>
                            <tr>
                                <th>Distances</th>
                                {Object.values(this.state.distFound).map(
                                    (x) => (
                                        <td>{x}</td>
                                    )
                                )}
                            </tr>
                        </table>
                    </div>
                    {this.state.stage === 1 && (
                        <div className="footer">
                            <p>
                                Enter distance from source to {this.state.snode}
                            </p>
                            <input
                                type="text"
                                value={this.state.d}
                                onChange={this.changeD}
                            />
                            <button onClick={this.setDist}>Check</button>
                        </div>
                    )}
                    {this.distFound}
                </div>
            </div>
        );
    }
}
